import { useState } from 'react';

import { Button } from '../../../components/button/button';
import { Text } from '../../../components/texts/text';
import Title from '../../../components/texts/title';
import { _sizeHeading, _sizeText } from '../../../core/core';
import { useLocalStorage } from '../../../shared/hooks/useLocalStorage';
import './PreviewNotifly.css';
import { SettingNotifly } from './SettingNotifly';

export const PreviewNotifly = () => {
    const [isFisrtView, setIsFisrtView] = useLocalStorage("notifly_first_view", true);
    const [isSettingNotifly, setIsSettingNotifly] = useState(false);

    const handleClick = () => {
        setIsFisrtView(false);
        setIsSettingNotifly(true);
    }

    return (
        <div className="preview-notifly-container">
            <div className={`preview-notifly  preview-notifly__first-${isFisrtView}`}>
                <div className="preview-notifly-content">
                    <Title type={_sizeHeading.h3}>Настройте уведомления</Title>
                    <Text size={_sizeText.m}>
                        Включите нужные уведомления, чтобы следить за заданиями и при необходимости контролировать процесс
                    </Text>
                </div>
                <Button className="preview-notifly-button" onClick={handleClick}>
                    Настроить
                </Button>
            </div>
            {isSettingNotifly && <SettingNotifly handleClose={() => setIsSettingNotifly(false)} />}
        </div>
    );
};